import logoColor from '@brand/logo/svg/logo-en-ar-color.svg';
import logoWhite from '@brand/logo/svg/logo-en-ar-white.svg';
import markColor from '@brand/logo/svg/mark-color.svg';
import markWhite from '@brand/logo/svg/mark-white.svg';
import mascotGroup from '@brand/mascot/mascot-01-1024.webp';
import mascotWave from '@brand/mascot/mascot-512.webp';

import { useLang } from '../i18n.ts';
import { cx } from './ui.tsx';

/** The full bilingual logo; the white version is used in dark mode (logo colors unchanged, O10). */
export function Logo({ className }: { readonly className?: string }) {
  const { t } = useLang();
  return (
    <>
      <img src={logoColor} alt={t('app.name')} className={cx('only-light', className)} />
      <img src={logoWhite} alt={t('app.name')} className={cx('only-dark', className)} />
    </>
  );
}

/** The "dob" wordmark for small places (sidebar, top bar). */
export function Mark({ className }: { readonly className?: string }) {
  return (
    <>
      <img src={markColor} alt="" className={cx('only-light', className)} />
      <img src={markWhite} alt="" className={cx('only-dark', className)} />
    </>
  );
}

/** Mascot illustrations are decorative: empty alt text, hidden from screen readers. */
export function MascotWave({ className }: { readonly className?: string }) {
  return <img src={mascotWave} alt="" aria-hidden className={className} />;
}

export function MascotGroup({ className }: { readonly className?: string }) {
  return <img src={mascotGroup} alt="" aria-hidden className={className} />;
}
